// "How I Coordinate a Team of AI Agents" — Mission agent-coordination short.
// Built on the Cold Compute / Neon kit. ~98s @ 30fps.
//
// Topic: how EAKC's multi-agent missions coordinate WITHOUT agents chatting
// directly — a shared, versioned blackboard (mission_blackboard_entries,
// migration 113) + step dependencies (blocked_by) + the orchestrator dispatch
// loop. Distinct from the parallel-execution video: this is the shared-MEMORY
// coordination mechanism, not the parallelism.
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames; captions are sticky, so
// each scene's duration ≈ (lastCaption.fromSec + ~6) * 30.
export const SCENE = {
  hook: { start: 0, duration: 150 }, //        0:00–0:05  agents don't talk to each other
  problem: { start: 150, duration: 360 }, //   0:05–0:17  the naive "let them chat" trap
  board: { start: 510, duration: 360 }, //     0:17–0:29  the shared blackboard (mig 113)
  deps: { start: 870, duration: 360 }, //      0:29–0:41  blocked_by — the dependency DAG
  loop: { start: 1230, duration: 390 }, //     0:41–0:54  the orchestrator dispatch loop
  code: { start: 1620, duration: 420 }, //     0:54–1:08  producer writes → consumer reads
  gate: { start: 2040, duration: 360 }, //     1:08–1:20  expected_outputs: trust, verified
  outro: { start: 2400, duration: 360 }, //    1:20–1:32
} as const;

export const TOTAL_DURATION = 2760; // 92s

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
